function DollarIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 15.9203H13.4C14.05 15.9203 14.59 15.3403 14.59 14.6403C14.59 13.7703 14.28 13.6003 13.77 13.4203L12.76 13.0703V15.9203H12.75Z"
        fill="#5570F1"
      />
      <path
        d="M11.9701 1.89845C6.45007 1.91845 1.98007 6.40845 2.00007 11.9285C2.02007 17.4485 6.51007 21.9185 12.0301 21.8985C17.5501 21.8785 22.0201 17.3885 22.0001 11.8685C21.9801 6.34845 17.4901 1.88845 11.9701 1.89845ZM14.2601 11.9985C15.0401 12.2685 16.0901 12.8485 16.0901 14.6385C16.0901 16.1785 14.8801 17.4185 13.4001 17.4185H12.7501V17.9985C12.7501 18.4085 12.4101 18.7485 12.0001 18.7485C11.5901 18.7485 11.2501 18.4085 11.2501 17.9985V17.4185H10.8901C9.25007 17.4185 7.92007 16.0385 7.92007 14.3385C7.92007 13.9285 8.26007 13.5885 8.67007 13.5885C9.08007 13.5885 9.42007 13.9285 9.42007 14.3385C9.42007 15.2085 10.0801 15.9185 10.8901 15.9185H11.2501V12.5385L9.74007 11.9985C8.96007 11.7285 7.91007 11.1485 7.91007 9.35845C7.91007 7.81845 9.12007 6.57845 10.6001 6.57845H11.2501V5.99845C11.2501 5.58845 11.5901 5.24845 12.0001 5.24845C12.4101 5.24845 12.7501 5.58845 12.7501 5.99845V6.57845H13.1101C14.7501 6.57845 16.0801 7.95845 16.0801 9.65845C16.0801 10.0685 15.7401 10.4085 15.3301 10.4085C14.9201 10.4085 14.5801 10.0685 14.5801 9.65845C14.5801 8.78845 13.9201 8.07845 13.1101 8.07845H12.7501V11.4585L14.2601 11.9985Z"
        fill="#5570F1"
      />
      <path
        d="M9.41992 9.36812C9.41992 10.2381 9.72992 10.4081 10.2399 10.5881L11.2499 10.9381V8.07812H10.5999C9.94992 8.07812 9.41992 8.65812 9.41992 9.36812Z"
        fill="#5570F1"
      />
    </svg>
  );
}

export default DollarIcon;
